export default {
  skipOnlyChildSubsections: false,

  general: {
    showHomeButton: true,
    showFavourites: true,
    showSoldSlides: false,
    canInteractSoldProperties: false,
  },

  filter: {
    enabled: false,
  },

  labels: {
    dwellingSizeSuffix: { en: "sq" },
    viewLabel: { en: "Orientation" },
  },

  rightSidebar: {
    propertyGuide: {
      active: true,
      items: ["Coming Soon", "Available", "On Hold", "Sold"],
    },
  },

  markers: {
    onHold: {
      label: {
        en: "Deposited",
      },
    },
  },
};
